export default __webpack_public_path__ + "static/media/c005-whatsapp-03-en.26c47984.png";